import { ConsultationPageTranslations } from "./types";

export const deTranslations: ConsultationPageTranslations = {
    pageTitle: "Konsilanfoderung",
    specialtyLabel: "Fachrichtung",
    specialtyOptions: [
        { value: "cardiothoracic", label: "Kardiothorakale Chirurgie" },
        { value: "ent", label: "HNO" },
        { value: "general_surgery", label: "Allgemeine Chirurgie" },
        { value: "neurosurgery", label: "Neurochirurgie" },
        { value: "psychiatry", label: "Psychiatrie" },
        { value: "trauma_ortho_surgery", label: "Orthopädie" },
        { value: "urology", label: "Urologie" },
    ],
    summaryLabel: "Anamnese",
    reasonLabel: "Klinische Fragestellung",
    clearButtonText: "Löschen",
    submitButtonText: "Absenden",
    pending: "Ausstehende Konsilbefunde",
    available: "Verfügbare Konsilbefunde",
    consultations: "Konsilbefunde",
    selectPlaceholder: "Auswählen...",
    save: "Speichern",
    addAnyNotes: "Fügen Sie beliebige Notizen hinzu",
    notesSection: "Ihre Anmerkungen",
    viewReport: "Konsilbefund ansehen",
    report: "Konsilbefund",
    consultationReport: "Konsilbefund",
    reasonForConsultation: "Klinische Fragestellung",
    noReason: "Kein Grund angegeben"
};